import React, { useState, useEffect, useRef, useContext } from 'react'
import styled from 'styled-components'
import '../../styleLess/signature/Taskinbox.scss'
import '../../styleLess/signature/tabswitch.scss'
import '../../styleLess/signature/new-status-styles.scss'
import { Col, Input, Modal, Row, Tooltip, DatePicker } from 'antd'
import {
  CalendarOutlined,
  ExclamationCircleOutlined,
  InboxOutlined,
  LockOutlined,
  RightOutlined,
  SearchOutlined,
  TagsFilled,
} from '@ant-design/icons'
import { getTaskAll } from '../../api/TaskInbox/taskInboxapi'
import { useHistory } from 'react-router-dom'
import { getCookie, setCookie } from '../../helper/cookie'
import bin from 'icons/createproject/Subtask.svg'
import moment from 'moment'
import { Layout } from 'antd'
import loadingSvg from 'icons/robot1.svg'
import loadingAnimationSvg from 'icons/three-dots.svg'
const { Header, Content } = Layout
import { Helmet } from 'react-helmet'
import { getPermissionControl } from 'api/Admin/rolePermission'
import { CounterContext } from 'redux/Golbalvalues'
import WaitingOnModalCommon from 'common/Dependencies/Modal/modal.waitingOn'
import BockingModalCommon from 'common/Dependencies/Modal/modal.bocking'
import TasksModalCommon from 'common/Dependencies/Modal/modal.tasks'
import renderIconDependency from 'common/Dependencies/RenderIconDependency/renderIconDependency'
const { RangePicker } = DatePicker
var today = new Date()
var start_date = new Date()
var date_retro = moment(start_date.setMonth(start_date.getMonth() - 3)).format(
  'YYYY-MM-DD',
)
var datenow = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate()
var current_date = moment(datenow).format('YYYY-MM-DD')
const Bodier = styled.div``
const Collapes = styled.div``
const initalState = {
  data: [],
  isLoading: true,
}
let searchtext = ''
let current_status = ''
const Taskinbox = (props) => {
  const [mode, Setmode] = useState(true)
  const [OneUnitFocus, setOneUnitFocus] = useState(1)
  const [showCollapes, setshowCollapes] = useState(true)
  const [render, setRender] = useState(1)
  const [isLoading, setIsLoading] = useState(initalState.isLoading)
  const [iconRB, seticonRB] = useState(true)
  const [arrayList, setarrayList] = useState([])
  const token = getCookie('access_token_admin')
  const roleUser = getCookie('roleUser')
  const [dataArray, setdataArray] = useState(initalState.data)
  const passwordInput = useRef(null)
  const [dbms, setDbms] = useState([])
  const [research, setResearch] = useState(false)
  const [lockedTab, setLockedtab] = useState(false)
  const [effectQuery, setEffectquery] = useState(false)
  const [isOpenModalDependencies, setIsOpenModalDependencies] = useState(false)
  const [dataModalDependencies, setDataModalDependencies] = useState([])
  const [dataFirst, setDataFirst] = useState(true)
  const dataCookieFilter = getCookie('taskinbox_filter')
  const dataCookieFilterDate = getCookie('taskinbox_filter_date')
  const [searchText, setSearchText] = useState('')
  const [dateRange, setDateRange] = useState()
  //checkrole
  const { mainRoleUser, setPathActive } = useContext(CounterContext)
  //check permission
  const getPermission = async () => {
    let checkRead = false
    await getPermissionControl({
      token: token,
    })
      .then(async (response) => {
        const { status, data, error } = response
        if (roleUser == 1) {
          checkRead = true
        }
        if (error) {
          return true
        }
        if (status === 200) {
          data.result?.permission?.map((item) => {
            if (item.menu_id == 4) {
              checkRead = true
            }
            if (item.menu_id == 5) {
              checkRead = true
            }
          })
          checkRead ? _ : history.push(`/no-permission`)
        }
      })
      .catch((error) => {
        console.error(error)
      })
  }
  useEffect(() => {
    if (token) {
      setPathActive('/taskinbox')
      getPermission()
    }
  }, [token])

  const dataTaskInbox = async () => {
    setIsLoading(true)

    const payload =
      dateRange !== undefined
        ? {
          start_date: dateRange[0].format('YYYY-MM-DD'),
          end_date: dateRange[1].format('YYYY-MM-DD'),
        }
        : {}

    await getTaskAll({
      params: payload,
      token: token,
    })
      .then(async (response) => {
        const { status, data, error } = response

        if (error) {
          await setdataArray([])
          setRender(0)
          return true
        }
        if (status === 200) {
          setRender(1)
          await setdataArray(data)
          await setIsLoading(false)
        } else {
          await setIsLoading(false)
          setdataArray([])
          setRender(0)
          return true
        }
      })
      .catch((error) => {
        setRender(0)
        setIsLoading(false)
        setdataArray([])
        console.error(error)
      })
  }
  const TranfromDatabase = () => {
    let Modify = []
    dataArray.map((item) => {
      let purginArray = []
      if (item.task != null) {
        item.task.map((it) => {
          const Taskconstant = {
            cando: it.cando,
            code: it.code,
            flow_status: it.flow_status,
            id: it.id,
            level: it.level,
            permission_name: it.permission_name,
            plan_end: it.plan_end,
            plan_start: it.plan_start,
            project_id: it.project_id,
            subtask: it.subtask,
            title: it.title,
            permission_id: it.permission_id,
            waiting: it.waiting,
            blocking: it.blocking,
            tasks: it.tasks,
          }
          purginArray.push(Taskconstant)
        })
      }
      const Projectconstant = {
        project_id: item.project_id,
        title: item.title,
        status_id: item.status_id,
        status_name: item.status_name,
        complete_flow: item.complete_flow,
        kickoff: item.kickoff,
        closure: item.closure,
        task: purginArray,
        permission_id: item.permission_id,
        waiting: item.waiting,
        blocking: item.blocking,
        tasks: item.tasks,
      }
      Modify.push(Projectconstant)
    })

    setDbms(Modify)
    setLockedtab(true)
  }

  useEffect(() => {
    if (dataArray.length != 0) {
      TranfromDatabase()
    }
  }, [dataArray])

  const EventIcontoUse = (data) => {
    let Focus = 0
    for (var i = 0; i < arrayList.length; i++) {
      if (arrayList[i].id == data.id) {
        Focus = data.id
      }
    }
    if (data.subtask != null) {
      return (
        <RightOutlined
          className={iconRB && Focus ? 'RightOutlined' : 'active-RightOutlined'}
          onClick={() => handleshowCollapes(data)}
        />
      )
    } else if (data.subtask == null) {
      return <RightOutlined className="null-event-Icons" />
    }
  }

  const handleshowCollapes = (data) => {
    WriteId(data.id)
  }
  const WriteId = (id) => {
    setarrayList([
      ...arrayList,
      {
        id: id,
      },
    ])
    ShowandHidden(id)
  }

  const ShowandHidden = (id) => {
    var addData = 0
    for (var i = 0; i < arrayList.length; i++) {
      if (arrayList[i].id == id) {
        addData = id
      }
    }
    if (addData == id) {
      handleRemove(id)
    } else if (addData != id) {
      setshowCollapes(true)
      seticonRB(true)
    }
  }

  const handleRemove = (id) => {
    const newTag = arrayList.filter((item) => item.id !== id)
    setarrayList(newTag)
  }

  /**
   * ฟังก์ชันสำหรับตั้งค่า DateRange ตามไตรมาสปัจจุบัน
   * @returns {Array} array ที่มี [startDate, endDate] เป็น moment objects
   */
  const getQuarterDateRange = () => {
    const today = new Date()
    const currentYear = today.getFullYear()
    const currentMonth = today.getMonth() + 1 // JavaScript months are 0-based

    let startDate, endDate

    if ([1, 2, 3].includes(currentMonth)) {
      // Q1: January - March
      startDate = moment(`${currentYear}-01-01`, 'YYYY-MM-DD')
      endDate = moment(`${currentYear}-03-31`, 'YYYY-MM-DD')
    } else if ([4, 5, 6].includes(currentMonth)) {
      // Q2: April - June
      startDate = moment(`${currentYear}-04-01`, 'YYYY-MM-DD')
      endDate = moment(`${currentYear}-06-30`, 'YYYY-MM-DD')
    } else if ([7, 8, 9].includes(currentMonth)) {
      // Q3: July - September
      startDate = moment(`${currentYear}-07-01`, 'YYYY-MM-DD')
      endDate = moment(`${currentYear}-09-30`, 'YYYY-MM-DD')
    } else {
      // Q4: October - December
      startDate = moment(`${currentYear}-10-01`, 'YYYY-MM-DD')
      endDate = moment(`${currentYear}-12-31`, 'YYYY-MM-DD')
    }

    return [startDate, endDate]
  }

  const onChangeDate = (dates, type) => {
    const cookieDatesData = {
      dateRange: dates
        ? [dates[0].format('YYYY-MM-DD'), dates[1].format('YYYY-MM-DD')]
        : null,
    }

    const expirationDate = new Date()
    expirationDate.setFullYear(expirationDate.getFullYear() + 1)
    setCookie('taskinbox_filter_date', JSON.stringify(cookieDatesData), {
      expires: expirationDate,
    })
    setDateRange(dates)
  }

  const handleSelect = (check) => {
    setEffectquery(!effectQuery)
    if (lockedTab === true) {
      TranfromDatabase()
      if (check == 1) {
        Setmode(true)
        setOneUnitFocus(1)
      } else if (check == 2) {
        Setmode(true)
        setOneUnitFocus(2)
        current_status = 'Not start'
      } else if (check == 3) {
        Setmode(true)
        setOneUnitFocus(3)
        current_status = 'On time'
      } else if (check == 4) {
        Setmode(true)
        setOneUnitFocus(4)
        current_status = 'Complete'
      }
    }
  }
  useEffect(() => {
    if (OneUnitFocus != 1) {
      StatusSearch(current_status)
    }
    if (searchtext !== '') {
      BigSearch(searchtext)
    }
  }, [OneUnitFocus, research, effectQuery])

  useEffect(() => {
    if (token) {
      // ตั้งค่า dateRange
      if (dataCookieFilterDate) {
        // ใช้ค่าจาก cookie ถ้ามี
        const filterDate = JSON.parse(dataCookieFilterDate)
        setDateRange([
          moment(filterDate.dateRange[0], 'YYYY-MM-DD'),
          moment(filterDate.dateRange[1], 'YYYY-MM-DD'),
        ])
      } else {
        // ตั้งค่าวันที่เป็นไตรมาสปัจจุบัน
        setDateRange(getQuarterDateRange())
      }

      // ตั้งค่าอื่นๆ
      searchtext = dataCookieFilter
      window.scrollTo(0, 0)
    }
  }, [token])

  useEffect(() => {
    if (token && dateRange !== undefined) {
      if (dateRange[0] && dateRange[1]) {
        dataTaskInbox()
        window.scrollTo(0, 0)
      }
    }
  }, [dateRange])

  const history = useHistory()
  const DetailTask = (data, sprintflowId, id, item) => {
    history.push({
      pathname: `taskinbox/${data.project_id}/${id}/update`,
      state: { data: item },
    })
  }
  const ReturnForonClicktitle = (data, item) => {
    if (item.permission_id == 7) {
      return (
        <Row className="row-title-for-onclick">
          <Tooltip title="You don't have permission">
            <div style={{ display: 'grid' }}>
              <h5 className=" cutter-text-line-1">{item.title}</h5>
            </div>
          </Tooltip>
          <LockOutlined className="lockoutlined" />
        </Row>
      )
    } else {
      return (
        <Row className="row-title-for-onclick">
          <div style={{ display: 'grid' }}>
            <h5
              className="onclick-open cutter-text-line-1 code"
              onClick={() => DetailTask(data, item.id, item.id, item)}
            >
              {item.title}
            </h5>
          </div>
        </Row>
      )
    }
  }
  const ReturnCandoEvent = (values) => {
    if (values === 'N') {
      return (
        <Tooltip title={'Waiting for approval decision task'}>
          <ExclamationCircleOutlined className="exclamation-icon" />
        </Tooltip>
      )
    }
  }

  const firstContentplay = () => {
    if (isLoading) {
      return (
        <div
          className="taskInbox-style"
          style={{ display: 'flex', flexDirection: 'column' }}
        >
          <img className="robot" src={loadingSvg} alt="Loading" />
          <img
            src={loadingAnimationSvg}
            style={{ marginTop: 16 }}
            alt="Loading animation"
          />
        </div>
      )
    }

    if (dbms.length === 0) {
      return (
        <div className="no-data-state-task-inbox">
          <InboxOutlined className="icon" />
          <h2>No data or not found Task and subtask</h2>
        </div>
      )
    }

    if (dbms.length != 0) {
      return dbms.map((item) => {
        let j = 0

        if (item.task != undefined && item.task != null) {
          j = item.task.length
        }
        return (
          <Collapes className="Collapes">
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <div style={{ display: 'grid', maxWidth: '60%' }}>
                <h3 className="cutter-text-line-1 ">{item.title}</h3>
              </div>

              <h3 style={{ marginLeft: 8 }}>({j})</h3>
            </div>
            {renderMasterTask(item)}
          </Collapes>
        )
      })
    }
  }

  const modalDependencies = () => {
    return (
      <div className="modal-dependencies">
        <div className="header-modal">Dependencies</div>
        <div className="project-id-style">
          <div className="text">{dataModalDependencies?.code}</div>
          <div
            className={`Status  ${dataModalDependencies?.flow_status === 'Not start'
              ? 'status-not-start'
              : dataModalDependencies?.flow_status === 'On time'
                ? 'status-on-time'
                : dataModalDependencies?.flow_status === 'Delay'
                  ? 'status-delay'
                  : dataModalDependencies?.flow_status === 'On hold'
                    ? 'status-on-hold'
                    : dataModalDependencies?.flow_status === 'Complete'
                      ? 'status-complete'
                      : 'status-default'
              }`}
            style={{ minWidth: 'fit-content' }}
          >
            <span className="smallStatus ">{dataModalDependencies?.flow_status}</span>
          </div>
        </div>
        <div className="project-name-style">{dataModalDependencies?.title}</div>
        <WaitingOnModalCommon dataTasks={dataModalDependencies?.waiting_on || []} />
        <BockingModalCommon dataTasks={dataModalDependencies?.blocking || []} />
        <TasksModalCommon dataTasks={dataModalDependencies?.tasks || []} />
      </div>
    )
  }

  const renderMasterTask = (data) => {
    let StylesBlock = false
    if (data.complete_flow === 'N') {
      StylesBlock = true
    } else {
      StylesBlock = false
    }
    if (data.task !== null && data.task !== undefined) {
      return data.task.map((item) => {
        let number = 0
        if (item.subtask !== null && item.subtask !== undefined) {
          number = item.subtask.length
        }

        let Focus = 0
        for (var i = 0; i < arrayList.length; i++) {
          if (arrayList[i].id == item.id) {
            Focus = item.id
          }
        }

        return (
          <div className="Master-Collapes">
            {StylesBlock === true ? (
              <Tooltip
                placement="top"
                title="Can’t open the task that is still editing in sprint task flow"
              >
                <div className="blocked-task"></div>
              </Tooltip>
            ) : (
              ''
            )}

            <div className="Container-master">
              <div
                className={`tab-color-follow  ${item.flow_status === 'Not start'
                  ? 'status-not-start'
                  : item.flow_status === 'On time'
                    ? 'status-on-time'
                    : item.flow_status === 'Delay'
                      ? 'status-delay'
                      : item.flow_status === 'On hold'
                        ? 'status-on-hold'
                        : item.flow_status === 'Complete'
                          ? 'status-complete'
                          : 'status-default'
                  }`}
              ></div>
              <div className="MRML-Responsive">
                <div className="M-R-container">
                  {EventIcontoUse(item)}

                  <TagsFilled className="TagsFilled" />
                  <h5
                    className="code"
                    onClick={() => DetailTask(data, item?.id, item?.id, item)}
                  >
                    {item.code}
                  </h5>
                  <div
                    className={`Status  ${item.flow_status === 'Not start'
                      ? 'status-not-start'
                      : item.flow_status === 'On time'
                        ? 'status-on-time'
                        : item.flow_status === 'Delay'
                          ? 'status-delay'
                          : item.flow_status === 'On hold'
                            ? 'status-on-hold'
                            : item.flow_status === 'Complete'
                              ? 'status-complete'
                              : 'status-default'
                      }`}
                    style={{ minWidth: 'fit-content' }}
                  >
                    <span className="smallStatus ">{item.flow_status}</span>
                  </div>
                  <span className="small tasknumber">{number} subtasks</span>
                  <div className="block-box">
                    {ReturnForonClicktitle(data, item)}
                    {ReturnCandoEvent(item.cando)}
                  </div>
                  {renderIconDependency(
                    item,
                    setIsOpenModalDependencies,
                    setDataModalDependencies,
                  )}
                  {/* dependency main*/}
                </div>
                <div className="M-L-container">
                  <CalendarOutlined className="CalendarOutlined"></CalendarOutlined>
                  <p>
                    {moment(item.plan_start).format('DD/MM/YYYY')} - {''}
                    {moment(item.plan_end).format('DD/MM/YYYY')}
                  </p>
                  <div className=" small tasknumber-responsive">
                    <div className="point"></div> {number} subtasks
                  </div>
                </div>
              </div>
            </div>
            <div
              className={
                showCollapes && Focus ? 'Showsub-collapes' : 'active-Showsub-collapes'
              }
            >
              {renderSubTask(data, item.id, item.subtask)}
            </div>
          </div>
        )
      })
    }
  }

  const renderSubTask = (dataProject, sprintflowId, data) => {
    if (data != null) {
      return data.map((item, index) => {
        return (
          <div className="Container-subitem ">
            <div className="a-container">
              <div className="reverse-container-responsive">
                <div>
                  <p
                    className="code cutter-text-line-1 "
                    onClick={() => DetailTask(dataProject, sprintflowId, item.id, item)}
                  >
                    {item.code}
                  </p>
                </div>
                <div
                  className={`Status  ${item.flow_status === 'Not start'
                    ? 'status-not-start'
                    : item.flow_status === 'On time'
                      ? 'status-on-time'
                      : item.flow_status === 'Delay'
                        ? 'status-delay'
                        : item.flow_status === 'On hold'
                          ? 'status-on-hold'
                          : item.flow_status === 'Complete'
                            ? 'status-complete'
                            : 'status-default'
                    }`}
                  style={{ overflow: 'hidden' }}
                >
                  <span className="smallStatus "> {item.flow_status} </span>
                </div>
              </div>
              <div style={{ display: 'grid', maxWidth: '60%' }}>
                <p
                  className="code-custom cutter-text-line-1 "
                  onClick={() => DetailTask(dataProject, sprintflowId, item.id, item)}
                >
                  {item.title}
                </p>
              </div>

              <div className="cando-check-content">{ReturnCandoEvent(item.cando)}</div>
              {renderIconDependency(
                item,
                setIsOpenModalDependencies,
                setDataModalDependencies,
              )}
              {/* {renderIconDependency(item)} */}
              {/* dependency sub*/}
            </div>
            <div className="b-container">
              <CalendarOutlined className="CalendarOutlined" />
              <p>
                {moment(item.plan_start).format('DD/MM/YYYY')} -{' '}
                {moment(item.plan_end).format('DD/MM/YYYY')}
              </p>
            </div>
          </div>
        )
      })
    }
  }

  const renderContent = () => {
    return (
      <>
        <Layout className="layout-taskinbox">
          <Helmet>
            <title>AXONS PROJECT | Task Inbox</title>
          </Helmet>
          <Modal
            visible={isOpenModalDependencies}
            footer={false}
            onCancel={() => {
              setIsOpenModalDependencies(false)
              setDataModalDependencies([])
            }}
            width={744}
            centered
          >
            {modalDependencies()}
          </Modal>
          <Header
            className="header-responsive-taskinbox"
            style={{ margin: 0, padding: 0 }}
          >
            <h1 className="no-breadcrumb">Task Inbox</h1>
            <div className="flexible-header" style={{ display: 'flex', gap: 8 }}>
              <RangePicker
                onChange={onChangeDate}
                value={dateRange}
                placeholder={['Start planned date', 'End planned date']}
                size="large"
                allowClear={false}
                style={{ minWidth: '350px' }}
              />

              <Input
                prefix={<SearchOutlined />}
                className="Search with-Taskbox"
                placeholder="Project name, Task, Sub task"
                disabled={isLoading}
                value={searchtext}
                onChange={(e) => {
                  onChangeSearch(e.target.value)
                }}
                style={{ width: '100%' }}
                allowClear
                size="large"
                ref={passwordInput}
              />
            </div>
          </Header>

          {render === 1 ? (
            <Content className="Bodier" style={{ margin: 0 }}>
              <div className="padding-responsive-tab">
                <Row className="containerTab">
                  <Col
                    className={
                      mode && OneUnitFocus == 1
                        ? 'TabbarResponsive all'
                        : 'active-Tabbar-Responsive all-active'
                    }
                    onClick={() => handleSelect(1)}
                  >
                    <h3>All</h3>
                  </Col>
                  <Col
                    className={
                      mode && OneUnitFocus == 2
                        ? 'TabbarResponsive todo'
                        : 'active-Tabbar-Responsive todo-active'
                    }
                    onClick={() => handleSelect(2)}
                  >
                    <h3>Not Start</h3>
                  </Col>
                  <Col
                    className={
                      mode && OneUnitFocus == 3
                        ? 'TabbarResponsive inpo'
                        : 'active-Tabbar-Responsive inpo-active'
                    }
                    onClick={() => handleSelect(3)}
                  >
                    <h3>On Time</h3>
                  </Col>
                  <Col
                    className={
                      mode && OneUnitFocus == 4
                        ? 'TabbarResponsive done'
                        : 'active-Tabbar-Responsive done-active'
                    }
                    onClick={() => handleSelect(4)}
                  >
                    <h3>Complete</h3>
                  </Col>
                </Row>
              </div>

              {firstContentplay()}
            </Content>
          ) : (
            <Bodier className="Bodier">
              <div className="empty-taskbox">
                <img className="img-emptystate" src={bin}></img>
                <h1>No Data</h1>
              </div>
            </Bodier>
          )}
        </Layout>
      </>
    )
  }

  const onChangeSearch = async (e) => {
    const expirationDate = new Date()
    expirationDate.setFullYear(expirationDate.getFullYear() + 1)
    setCookie('taskinbox_filter', e, { expires: expirationDate })
    await BigSearch(e)
  }

  const BigSearch = async (value) => {
    const isValue = value === undefined ? '' : value
    searchtext = isValue
    //                            LEVEL 1
    await setDbms([
      ...dbms,
      dbms.map((item) => {
        if (item?.title?.toLowerCase().includes(isValue?.toLowerCase())) {
        } else {
          if (item.task != null) {
            let data = []

            item.task.map((item) => {
              if (item?.title?.toLowerCase().includes(isValue?.toLowerCase())) {
                if (item.subtask != null) {
                  setarrayList((prev) => [...prev, { id: item.id }])
                }
                data.push(item)
              } else {
                if (item.subtask != null) {
                  let data = []
                  let count = 0
                  let length_subtask = item.subtask.length
                  item.subtask.map((item) => {
                    if (item?.title?.toLowerCase()?.includes(isValue?.toLowerCase())) {
                      data.push(item)
                    } else {
                      count = count + 1
                      if (length_subtask == count) {
                        data = null
                      }
                    }
                  })
                  item.subtask = data
                }
              }
            })
          }
        }
      }),
    ])

    const newdata = dbms.filter((item) => item != undefined)
    await setDbms(newdata)
    //                            LEVEL 3
    await setDbms([
      ...dbms,
      dbms.map((item) => {
        if (item?.title?.toLowerCase().includes(isValue?.toLowerCase())) {
        } else {
          if (item.task !== null) {
            let data = []
            let count = 0
            let length_task = item?.task?.length
            item?.task?.map((item) => {
              if (
                item?.subtask !== null ||
                item?.title?.toLowerCase().includes(isValue?.toLowerCase())
              ) {
                data.push(item)
              } else {
                count = count + 1
                if (length_task == count) {
                  data = null
                }
              }
            })
            item.task = data
          }
        }
      }),
    ])
    const newdata2 = dbms.filter((item) => item != undefined)
    await setDbms(newdata2)

    const newdata3 = dbms.filter((item) => item.task !== null && item.task.length != 0)
    await setDbms(newdata3)
    if (isValue === '') {
      TranfromDatabase()
      setResearch(!research)
      setarrayList([])
      if (passwordInput.current) {
        passwordInput.current.focus()
      }
    }
  }

  useEffect(() => {
    if (dbms.length > 1 && dataCookieFilter && dataFirst) {
      const data = dataCookieFilter
      onChangeSearch(data)
      setDataFirst(false)
    }
  }, [dbms])

  const StatusSearch = async (value) => {
    const terminalData = dbms.map((item) => {
      item.task?.map((item) => {
        if (item.flow_status === value) {
          if (item.subtask != null) {
            let dataIF = []
            let count = 0
            let length_subtask = item.subtask.length

            item.subtask.map((i) => {
              if (i.flow_status === value) {
                dataIF.push(i)
              } else {
                count = count + 1
                if (count == length_subtask) {
                  dataIF = null
                }
              }
            })
            item.subtask = dataIF
            return item
          } else if (item.subtask === null) {
            return item
          }
        } else if (item.flow_status !== value) {
          if (item.subtask !== null) {
            let dataElse = []
            let count = 0
            let length_subtask = item.subtask.length

            item.subtask.map((i) => {
              if (i.flow_status === value) {
                dataElse.push(i)
              } else {
                count = count + 1
                if (count == length_subtask) {
                  dataElse = null
                }
              }
            })
            item.subtask = dataElse
          } else if (item.subtask === null) {
          }
        }
      })
      return item
    })
    setDbms(terminalData)

    const centralData = terminalData.map((item) => {
      let j = []
      item.task?.map((item) => {
        if (item.flow_status === value || item.subtask !== null) {
          j.push(item)
        }
      })
      item.task = j
      return item
    })
    setDbms(centralData)
    const LastState = centralData.filter((item) => item.task.length != 0)
    setDbms(LastState)
  }

  return renderContent()
}

export default Taskinbox
